import React, { useState } from "react";

// i18n
import { useTranslation } from "react-i18next";

// Icons
import { FiMinimize } from "react-icons/fi";

// React Flow
import { ReactFlowProvider } from "@xyflow/react";

// MUI
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

// Contexts
import { useMasteryMap } from "../context";

// Components
import Modal from "../../../components/modal";
import MUISegmented from "../../../components/MUISegmented";

// Views
import Cards from "./Views/cards";
import Map from "./Views/map";
import Sources from "./Views/sources";

// Styles
import styles from "./modal.module.scss";

const MasteryMapModal = () => {
  const { t } = useTranslation();
  const { showModal, setShowModal } = useMasteryMap();

  // State
  const [activeTab, setActiveTab] = useState("card");

  const handleClose = () => {
    setShowModal(false);
  };

  const handleMinimize = () => {
    setShowModal(false);
  };

  // Render
  const renderHeader = () => {
    return (
      <div className="flex flex-row items-center justify-between">
        <Typography variant="h5" color="textPrimary">
          {t("masteryMap.title")}
        </Typography>

        <div className="flex flex-row gap-2 items-center">
          <MUISegmented
            options={[
              { label: t("masteryMap.modal.card"), value: "card" },
              { label: t("masteryMap.modal.map"), value: "map" },
              { label: t("masteryMap.modal.sources"), value: "sources" },
            ]}
            value={activeTab}
            onChange={setActiveTab}
          />

          <Button
            variant="text"
            color="secondary"
            onClick={handleMinimize}
            classes={{
              root: styles.minimizeButton
            }}
          >
            <FiMinimize className="w-4 h-4" />

            <span className="text-sm">
              {t("masteryMap.modal.minimize")}
            </span>
          </Button>
        </div>
      </div>
    );
  };

  return (
    <Modal
      open={showModal}
      onClose={handleClose}
      title={renderHeader()}
      className={styles.modal}
    >
      {activeTab === "card" && <Cards />}
      <ReactFlowProvider>
        {activeTab === "map" && <Map />}
      </ReactFlowProvider>
      {activeTab === "sources" && <Sources />}
    </Modal>
  );
};

export default MasteryMapModal;
